@import "../../common/_base";

@include button-reset();
@include box-sizing();

:host {
  /**
   * @prop --ch-tooltip-separation:
   * Specifies the separation between the action and the displayed tooltip.
   * @default 0px
   */
  --ch-tooltip-separation: 0px;

  /**
    * @prop --ch-tooltip-separation-x:
    * Specifies the separation between the action and the tooltip displayed
    * on the x-axis.
    * @default var(--ch-tooltip-separation)
    */
  --ch-tooltip-separation-x: var(--ch-tooltip-separation);

  /**
    * @prop --ch-tooltip-separation-y:
    * Specifies the separation between the action and the tooltip displayed
    * on the y-axis.
    * @default var(--ch-tooltip-separation)
    */
  --ch-tooltip-separation-y: var(--ch-tooltip-separation);

  display: contents;
}

ch-popover {
  --ch-popover-separation-x: var(--ch-tooltip-separation-x);
  --ch-popover-separation-y: var(--ch-tooltip-separation-y);
  animation: delay-visibility var(--ch-tooltip-delay) linear;

  &:not(.hydrated) {
    display: none;
    opacity: 0;
  }
}

@keyframes delay-visibility {
  0%,
  100% {
    opacity: 0;
  }
}

// ch-tooltip {
//   --ch-tooltip-separation: 12px;
//   --ch-tooltip-separation-x: var(--ch-tooltip-separation);
//   --ch-tooltip-separation-y: var(--ch-tooltip-separation);
//   --ch-tooltip-arrow-size: 10px;
//   --ch-tooltip-based: calc(1px - var(--ch-tooltip-arrow-size));
//   --ch-tooltip-centered: calc(50% - var(--ch-tooltip-arrow-size) / 2);
//   --ch-tooltip-75: calc(75% - var(--ch-tooltip-arrow-size) / 2);
//   --ch-tooltip-25: calc(25% - var(--ch-tooltip-arrow-size) / 2);
//   // display: flex;
//   // position: relative;
//   // width: 100%;
//   // height: 100%;
// }

// // - - - - - - - - - - - - - - - -
// //           Separation
// // - - - - - - - - - - - - - - - -
// ch-window[y-align="outside-start"] {
//   --ch-window-separation: var(--ch-tooltip-separation-y);
//   --ch-window-separation-y: calc(var(--ch-tooltip-separation-y) * -1);
// }

// ch-window[y-align="outside-end"] {
//   --ch-window-separation: var(--ch-tooltip-separation-y);
//   --ch-window-separation-y: var(--ch-tooltip-separation-y);
// }

// ch-window[x-align="outside-start"]
//   + :not(ch-window[y-align="outside-start"], ch-window[y-align="outside-end"]) {
//   --ch-window-separation: var(--ch-tooltip-separation-x);
//   --ch-window-separation-x: calc(var(--ch-tooltip-separation-x) * -1);
// }

// ch-window[x-align="outside-end"]
//   + :not(ch-window[y-align="outside-start"], ch-window[y-align="outside-end"]) {
//   --ch-window-separation: var(--ch-tooltip-separation-x);
//   --ch-window-separation-x: var(--ch-tooltip-separation-x);
// }

// // - - - - - - - - - - - - - - - -
// //           Tooltip Arrow
// // - - - - - - - - - - - - - - - -
// ch-window[y-align="outside-start"],
// ch-window[y-align="outside-start"][x-align="outside-start"],
// ch-window[y-align="outside-start"][x-align="outside-end"] {
//   .tooltip-content::after {
//     clip-path: polygon(0 0, 50% 100%, 100% 0);
//     inset-block-end: var(--ch-tooltip-based);
//   }
//   &[x-align="outside-start"] {
//     .tooltip-content::after {
//       inset-inline-end: 0;
//     }
//   }
//   &[x-align="outside-end"] {
//     .tooltip-content::after {
//       inset-inline-start: 0;
//     }
//   }
// }

// ch-window[y-align="outside-end"],
// ch-window[y-align="outside-end"][x-align="outside-end"],
// ch-window[y-align="outside-end"][x-align="outside-start"] {
//   .tooltip-content::after {
//     clip-path: polygon(50% 0, 100% 100%, 0 100%);
//     inset-block-start: var(--ch-tooltip-based);
//   }
//   &[x-align="outside-start"] {
//     .tooltip-content::after {
//       inset-inline-end: 0;
//     }
//   }
//   &[x-align="outside-end"] {
//     .tooltip-content::after {
//       inset-inline-start: 0;
//     }
//   }
// }

// ch-window[x-align="outside-start"] {
//   .tooltip-content::after {
//     clip-path: polygon(100% 50%, 0 0, 0 100%);
//     inset-inline-end: var(--ch-tooltip-based);
//   }
// }

// ch-window[x-align="outside-end"] {
//   .tooltip-content::after {
//     clip-path: polygon(100% 0, 0 50%, 100% 100%);
//     inset-inline-start: var(--ch-tooltip-based);
//   }
// }

// ch-window[x-align="center"] {
//   .tooltip-content::after {
//     inset-inline-start: var(--ch-tooltip-centered);
//   }
// }
// ch-window[x-align="inside-start"] {
//   .tooltip-content::after {
//     inset-inline-start: var(--ch-tooltip-75);
//   }
// }
// ch-window[x-align="inside-end"] {
//   .tooltip-content::after {
//     inset-inline-start: var(--ch-tooltip-25);
//   }
// }

// ch-window[y-align="inside-start"] {
//   .tooltip-content::after {
//     inset-block-start: var(--ch-tooltip-75);
//   }
// }
// ch-window[y-align="center"] {
//   .tooltip-content::after {
//     inset-block-start: var(--ch-tooltip-centered);
//   }
// }
// ch-window[y-align="inside-end"] {
//   .tooltip-content::after {
//     inset-block-start: var(--ch-tooltip-25);
//   }
// }

// .tooltip-content {
//   &::after {
//     content: " ";
//     position: absolute;
//     background-color: inherit;
//     width: var(--ch-tooltip-arrow-size);
//     height: var(--ch-tooltip-arrow-size);
//   }
// }
